import { useEffect, useRef } from "react"
import { useDrag, useDrop } from "react-dnd"
import { useDispatch, useSelector } from "react-redux"
import { boardChange, boardChangeCancel, updatedBoardTrue, orderChange as orderChangeBoardTask } from "../../../reducers/models/board/boardTaskList"
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import CardUserOne from "../../../components/card/CardUserOne";
import ScrollContainer from "react-indiana-drag-scroll";
import DateStartEndForList from "../../../components/task/DateStartEndForList";
import ErrorAdd from "../../../util/ErrorAdd";

function TaskItem({ index, model, id_type_appointment, errorOnShow, errorText, projectSelected, id_bord_type, responibleModal, onClick }) {
    /*
        id_type_appointment - Способ назначения ответственных для задач (старая/текущая доска)
        ID	Name	                    Description
        1	Вручную	                    Ответственный выбирается вручную на карточке задачи
        2	Не требует ответственных	Доска не требует назначения ответственных. Например: лист ожидания, TO DO, не разобранные задачи, архив...
        3	Выбор при перемещении	    При перемещении задачи на доску будет предложен выбор кого назначить.
        4	Тот кто переместил	        Ответственным автоматически становится тот кто переместил задачу на доску 
    */

    const id_object = 3;//Доски

    const dispatch = useDispatch()

    const stateBoardTaskList = useSelector((state) => state.boardTaskList);
    const stateBoardList = useSelector((state) => state.boardList);
    const stateSetting = useSelector((state) => state.setting);//Настройки

    const ref = useRef(null)
    const [{ handlerId }, drop] = useDrop({
        accept: 'board_task_' + model.ID_Project,
        drop: () => ({
            model, //Передаем в useDrag
        }),
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(model_, monitor) {
            if (!ref.current) {
                return
            }
            const dragIndex = model_.index
            const hoverIndex = index
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()
            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%

            // Dragging downwards  !!!!!!!!!!        
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }

            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }

            // Time to actually perform the action
            //moveBoardTask({ dragIndex: dragIndex, hoverIndex: hoverIndex, id_board_old: model.ID_Board, id_board_new: model_.model.ID_Board, id_board_task: model_.model.ID })

            dispatch(orderChangeBoardTask({ dragIndex: dragIndex, hoverIndex: hoverIndex, id_board_old: model.ID_Board, id_board_new: model_.model.ID_Board, id_board_task: model_.model.ID, id_project: model.ID_Project }))

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            model_.index = hoverIndex
        },
    })
    const [{ isDragging }, drag] = useDrag({
        type: 'board_task_' + model.ID_Project,
        item: () => {
            return { model, index }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            //item - Изменяемая модель
            if (monitor.getDropResult() !== null) {

                const ID_Board_Old = item.model.ID_Board;//ID_Board_Old
                const ID_Board_New = monitor.getDropResult().ID_Board; //ID_Board_New
                const dragIndex = item.index;
                const hoverIndex = index;

                if (ID_Board_New != undefined) {
                    //Перемещение на другую доску
                    if (ID_Board_New !== ID_Board_Old) {

                        //Способ назначения ответственных для задач (новая доска)
                        const id_type_appointment_new = stateBoardList.list.filter(a => a.ID === ID_Board_New)[0].ID_Type_Appointment;

                        dispatch(boardChange({ id_task: item.model.ID, id_board: ID_Board_New, dragIndex: dragIndex, hoverIndex: hoverIndex, id_bord_type: id_bord_type }));

                        axios.post('/api_tracker/board/taskMoving', { ID_Task: item.model.ID, ID_Board: ID_Board_New })
                            .then((res) => {
                                if (res.data.Status !== 1) {
                                    dispatch(boardChangeCancel());
                                    errorOnShow();
                                    errorText(res.data.Error);
                                }
                                else {
                                    if (id_type_appointment_new === 3) {
                                        responibleModal(ID_Board_New, projectSelected, item.model.ID);
                                    }
                                }
                            })
                            .catch((err) => {
                                errorOnShow();
                                errorText("Неизвестная ошибка");
                                dispatch(boardChangeCancel());
                                ErrorAdd(err, window.location.href);
                            });
                    }
                    //Перемещение в пределах одной доски
                    if (ID_Board_New === ID_Board_Old) {
                        dispatch(updatedBoardTrue());
                    }
                }
            }
        }
    })
    const opacity = isDragging ? 0 : 1

    //drag(drop(ref))


    useEffect(() => {
        //Выключаем перетаскивание если в проекте включены фильтры
        if (stateBoardTaskList.list.filter(a => a.ID_Project === model.ID_Project & (a.filter_label === 1 || a.filter_user === 1)).length > 0) {
            drag(null)
        }
        else {
            drag(drop(ref))
        }
    }, [stateBoardTaskList.list]);
    //drag(null)


    return (
        <>
            <div className="board_task" ref={ref} data-handler-id={handlerId} style={{ opacity }} >
                <div className={"card-body priority_border_color_" + model.Priority}>
                    <div className="d-flex" onClick={() => onClick(model)}>
                        <h5 className="card-title" >{model.Name}</h5>
                        {stateSetting.user !== null && stateSetting.user.ID === model.ID_Responsible && model.Viewed === false &&
                            <div style={{ marginLeft: 'auto' }}>
                                <span className="badge badge-menu warning badge-dot" > </span>
                            </div>
                        }
                    </div>
                    <small><DateStartEndForList date_start={model.Date_Start} date_end={model.Date_End} /></small>
                    {stateBoardTaskList.listCheckList.filter(a => a.ID_Item === model.ID).length > 0 &&
                        (
                            <>
                                <FontAwesomeIcon icon={faSquareCheck} className="mr-5" />
                                <b>{stateBoardTaskList.listCheckList.filter(a => a.ID_Item === model.ID & a.Completed == true).length}</b>
                                /
                                <b>{stateBoardTaskList.listCheckList.filter(a => a.ID_Item === model.ID).length}</b>
                            </>
                        )
                    }
                    <div>
                        <div className="badge_block" >
                            <ScrollContainer className="scroll-container">
                                {stateBoardTaskList.listLabel.filter(a => a.ID_Item === model.ID).map((label) => (
                                    <div key={label.ID_Label} className="badge_item" style={{ backgroundColor: label.Color }} >
                                        {label.Name}
                                    </div>
                                ))}
                            </ScrollContainer>
                        </div>
                    </div>
                    {id_type_appointment !== 2 && (
                        <div className="mt-5">
                            <CardUserOne key={model.ID_Responsible} idItem={model.ID} idObject={3} idUserSelected={model.ID_Responsible} data={{ ID_Board: model.ID_Board, ID_Project: model.ID_Project }} onlyChange={false} viewed={model.Viewed} />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
export default TaskItem;